
import React, { useState, useEffect, useContext } from "react";
import Footer from "./Footer";
import tmdbApi from "../api/tmdbApi";
// import Header from "./Header";add

import { useNavigate, Link, useLocation } from "react-router-dom";
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";

import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from '../assets/images/Dadi-logo.svg';
import outlineImg from '../assets/images/outline-img.svg';
import otpImage from '../assets/images/otp-image.svg';

let { appname, lambda } = window.app;

const SignUp = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { flag } = state || {};
    const [quizData, setQuizData] = useState(null);
    const [formData, setFormData] = useState({
        name: "", email: "", clinic: "", designation: "", phone: ""
    });
    const [handleExist, sethandleExist] = useState(false)
    const [errorData, setError] = useState({});
    const [errorDisplay, seterrorDisplay] = useState(false);
    const [imageCloudfront, setImg] = useState(false);
    const [showPwd, setShowPwd] = useState(false);
    const [showCnfPwd, setShowCnfPwd] = useState(false);
    const [success, setSuccess] = useState(false)
    const [title, setTitle] = useState("")

const {searchedFlag, setSearchedFlag, isLoading, setIsLoading,GetUserDataContext, processObject,sortTableAlpha, arrow, sortTableByDate, userData, companysearch, setCompanySearch, companyadvSearch, setCompanyAdvSearch, currentPage, setcurrentPage,   data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious ,setActiveMenuId, setActiveMenuObj,  GetTimeActivity} = useContext(contentContext)
    const [showOtpBox, setShowOtpBox] = useState(false);
    const [otp, setOtp] = useState('');
    const [email, setEmail] = useState('');
    const [isOtpLoading, setIsOtpLoading] = useState(false);
    const [isResendLoading, setIsResendLoading] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
        if (userData?.userType === "DOCTOR") {
            navigate("/cpc");
        } else if (userData?.userType && userData.userType !== "DOCTOR") {
            navigate("/dashboard");
        }
    }
}, [userData]);



    const verifyOTP = async () => {

        // let userType = localStorage.getItem('userType')

        setIsOtpLoading(true);
        try {
            let obj = {
                "email": email,
                "logintype": "otp",
                "otp": Number(otp),
            }
            if (localStorage.getItem("cpcid") && localStorage.getItem("cpcid") !== "null") {
                obj["cpcid"] = localStorage.getItem("cpcid")
            }
            const response = await tmdbApi.otpverify(obj);
            console.log(response)

            if (response?.result?.token) {

                toast.success("OTP verified successfully.", {
                    title: 'Success!',
                })

                let userType = response?.result.userType
        
                // // navigate('/signin');
                localStorage.setItem("cpcid", null);

                localStorage.setItem("token", response?.result?.token);
                localStorage.setItem("userId", response?.result?.userid);
                localStorage.setItem("userType", userType);
                localStorage.setItem("name", response?.result.name);
                localStorage.setItem("contact", response?.result.phoneNumber);

                // tmdbApi.navigatePage(userType,navigate)
                GetUserDataContext()
                navigate("/cpc")

                




            } else if (response?.result === "Invalid code entered") {
                toast.error("Invalid code entered", {
                    title: 'Error!',
                })
            }

            else {
                // Swal.fire({
                //     title: 'Error!',
                //     text: 'Invalid OTP. Please try again.',
                //     icon: 'error',
                //     confirmButtonText: 'OK'
                // });

                setOtp('')
                toast.error("Invalid OTP. Please try again.", {
                    title: 'Error!',

                });

            }
        } catch (error) {
            // Swal.fire({
            // title: 'Error!',
            // text: 'Something went wrong. Please try again later.',
            // icon: 'error',
            // confirmButtonText: 'OK'
            document.getElementById('otpInput').value = ''
            setOtp('')
            toast.error("Invalid OTP. Please try again.", {
                //position: "bottom-center",
                title: 'Error!'
            });
        } finally {
            setIsOtpLoading(false);
        }
    };

    const resendOTP = async () => {
        const payload = { email: email };
        setIsResendLoading("resend");
        try {
            const response = await axios.post(`${lambda}/resendOtp?appname=${appname}`, payload);
            if (response?.data?.result === 'Email Sent Successfully') {
                // Swal.fire({
                //     title: 'Success!',
                //     text: 'OTP resent to your email.',
                //     icon: 'success',
                //     confirmButtonText: 'OK'
                // toast.success("OTP resent to your email", {
                //     position: "bottom-center",
                //     title: 'Success!'
                // });
                setSuccess(true)
                setTitle("OTP resent to your email")
                document.getElementById('otp').value = ''
                setOtp('')
            } else {
                // Swal.fire({
                //     title: 'Error!',
                //     text: 'Invalid OTP. Please try again.',
                //     icon: 'error',
                //     confirmButtonText: 'OK'
                // });
                // toast.error("Please Enter Password", {
                //     title: 'Error!',
                // });

            }
        } catch (error) {
            // Swal.fire({
            //     title: 'Error!',
            //     text: 'Something went wrong. Please try again later.',
            //     icon: 'error',
            //     confirmButtonText: 'OK'
            // });
            // toast.error("Something went wrong. Please try again later", {
            //     title: 'Error!',
            // });

        } finally {
            setIsResendLoading("");
        }
    };


    useEffect(() => {
        if (localStorage.getItem("token1")) {
            navigate("/");
        }
        let userType = localStorage.getItem('userType')
        if(userType != ""){
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                "userType": userType, // Update the phone number field
            }));
        }

    }, [])

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);
    const onBackConfirm = async () => {
        sethandleExist(false);
        // setBackButtonPressed(true);


    }
    useEffect(() => {
        if (flag) {
            // Add event listener for popstate to detect when the user presses the back button
            const handlePopState = (event) => {
                event.preventDefault();
                navigate('/')

            };

            // Initially pushState to allow popstate to fire
            window.navigateState({}, document.title, window.location.href);

            // Add popstate listener
            window.addEventListener("popstate", handlePopState);

            return () => {
                // Cleanup event listener when component unmounts
                window.removeEventListener("popstate", handlePopState);
            };
        }

    }, []);

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    //     let quizinfo = JSON.parse(localStorage.getItem('q'))
    //     if (quizinfo) {
    //         setQuizData(quizinfo)
    //     }
    //     let userinfo = JSON.parse(localStorage.getItem('u'))
    //     if (userinfo) {
    //         setFormData(userinfo)
    //     }
    // }, []);



    const handleOTPChange = (e) => {
        // debugger
        const { name, value } = e.target;
        if (name === 'otp') {
            setOtp(value);
        }
    };



    const handleChange = (event) => {
        const { name, value } = event.target;

        // Check if the field being updated is the phone number
        if (name === "name") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...errorData, name: "" })

        } else if (name === "email") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setEmail(value)
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...errorData, email: "" })

        } else if (name === "clinic") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...errorData, clinic: "" })

        }

        // else if (name === "password") {
        //     // Validate phone number: only numbers and a maximum of 10 digits
        //     setFormData((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         [name]: value, // Update the phone number field
        //     }));

        //     setError({ ...errorData, password: "" })

        // } else if (name === "confirmpassword") {
        //     // Validate phone number: only numbers and a maximum of 10 digits
        //     setFormData((prevData) => ({
        //         ...prevData, // Keep the other fields intact
        //         [name]: value, // Update the phone number field
        //     }));

        //     setError({ ...errorData, confirmpassword: "" })

        // } 
        else if (name === "phone") {

            let numericValue = value.replace(/[-()]/g, '').replace(/\D/g, ""); // Remove non-numeric characters

            // Restrict to max 10 digits
            if (numericValue.length > 10) {
                numericValue = numericValue.slice(0, 10);
            }

            // Phone number should be exactly 10 digits
            const phoneRegex = /^\d{10}$/;
            if (numericValue === '' || phoneRegex.test(numericValue)) {
                setError((prevData) => ({
                    ...prevData,
                    "phone": "",
                }));
                seterrorDisplay(true);

            } else {
                setError((prevData) => ({
                    ...prevData,
                    "phone": "Please enter a valid phone address",
                }));
                seterrorDisplay(true);
            }
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                "phone": numericValue, // Update the phone number field
            }));
        }
        else if (name === "designation") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...errorData, designation: "" })

        } else {
            // Allow normal updates for other fields
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the changed field
            }));
        }
    };

    console.log("formData :", formData);

    const handleSubmit = (e) => {
        const isValid = formvalidation();
        if (isValid) {
            handleSignUp()
        }


    }


    function formvalidation() {
        let formIsValid = true;

        // Name Validation
        if (formData?.name === "") {
            setError((prevData) => ({
                ...prevData,
                "name": "Please enter name",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                "name": "",
            }));
        }

        if (formData?.designation === "") {
            setError((prevData) => ({
                ...prevData,
                "designation": "Please select designation",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                "designation": "",
            }));
        }


        //  if (formData?.userType === "") {
        //     setError((prevData) => ({
        //         ...prevData,
        //         ["userType"]: "Please select user type",
        //     }));
        //     seterrorDisplay(true);

        //     formIsValid = false;
        // } else {
        //     setError((prevData) => ({
        //         ...prevData,
        //         ["userType"]: "",
        //     }));
        // }


        // // Password Validation
        // const uppercaseRegex = /[A-Z]/;
        // const lowercaseRegex = /[a-z]/;
        // const numberRegex = /\d/;
        // // const specialCharRegex = /[@$!%*?&]/;

        // if (formData?.password === "") {
        //     setError((prevData) => ({
        //         ...prevData,
        //         ["password"]: "Please enter password",
        //     }));
        //     seterrorDisplay(true);

        //     formIsValid = false;
        // } else if (!uppercaseRegex.test(formData.password)) {
        //     setError((prevData) => ({
        //         ...prevData,
        //         ["password"]: "Password must contain at least one uppercase letter",
        //     }));
        //     seterrorDisplay(true);

        //     formIsValid = false;
        // } else if (!lowercaseRegex.test(formData.password)) {
        //     setError((prevData) => ({
        //         ...prevData,
        //         ["password"]: "Password must contain at least one lowercase letter",
        //     }));
        //     seterrorDisplay(true);

        //     formIsValid = false;
        // } else if (!numberRegex.test(formData.password)) {
        //     setError((prevData) => ({
        //         ...prevData,
        //         ["password"]: "Password must contain at least one number",
        //     }));
        //     seterrorDisplay(true);

        //     formIsValid = false;
        // } else {
        //     setError((prevData) => ({
        //         ...prevData,
        //         ["password"]: "",
        //     }));
        // }

        // // Confirm Password Validation
        // if (formData?.confirmpassword === "") {
        //     setError((prevData) => ({
        //         ...prevData,
        //         ["confirmpassword"]: "Please enter confirm password",
        //     }));
        //     seterrorDisplay(true);

        //     formIsValid = false;
        // } else if (formData?.confirmpassword !== formData?.password) {
        //     setError((prevData) => ({
        //         ...prevData,
        //         ["confirmpassword"]: "Confirm Password does not match Password",
        //     }));
        //     seterrorDisplay(true);

        //     formIsValid = false;
        // } else {
        //     setError((prevData) => ({
        //         ...prevData,
        //         ["confirmpassword"]: "",
        //     }));
        // }

        // Email Validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (formData?.email === "") {
            setError((prevData) => ({
                ...prevData,
                "email": "Please enter email",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else if (!emailRegex.test(formData?.email)) {
            setError((prevData) => ({
                ...prevData,
                "email": "Please enter a valid Email address",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                "email": "",
            }));
        }

        return formIsValid;
    }
    const onConfirm = () => {
        sethandleExist(false)
        setSuccess(false)
    }
    const onConfirm1 = () => {
        navigate("/login")
        setSuccess(false)
    }
    const handleSignUp = async () => {
        setIsResendLoading("signup")
        let fellowship = localStorage.getItem("fellowshipInterest")
        let fellowshipdate = localStorage.getItem("fellowshipInterestDate") 
        try {
            const { confirmpassword, ...dataToSend } = formData;
            if (fellowship) {
                dataToSend.fellowshipInterest = true;
                dataToSend.fellowshipate = fellowshipdate;
            }
           // let userType = localStorage.getItem('userType')
           // dataToSend["userType"] = userType
            const response = await tmdbApi.signUp({
                ...dataToSend,userType:'DOCTOR',
            });
            console.log(response);
            if (response?.statusCode == 200 && response?.result === "Invalid email or password") {
                setError(response?.result);
                setTimeout(function () { setError("") }, 3000);
                // toast.success("OTP sent to your email. Please enter it below.", {
                //     position: "bottom-center",
                //     title: 'Success!'
                // });
                // setBtnLoader("")
            } else if (response?.result=== "Emailid already exists") {
                setTitle(response?.result)
                setSuccess(true)
                setIsResendLoading("")
                // alert(1) 
                // sethandleExist(true)

                // toast.error(response?.result, {
                //     position: "bottom-center",
                //     title: 'Error!',

                // });
            } else {
                localStorage.removeItem('userType')
                console.log(response)
                
                // setSuccess(true)
                //  setTitle(response?.result)
                // toast.success(response?.result, {
                //     position: "bottom-center",
                //     title: 'Success!'
                // });
                setShowOtpBox(true);
                setIsResendLoading("")
            }

        } catch {
            console.log("error");
            // setBtnLoader("")
            setError("Invalid email or password");
            setTimeout(function () { setError("") }, 3000);
        }
    };

    const handleBack = (e) => {
         localStorage.removeItem("fellowshipInterest");
         localStorage.removeItem("fellowshipInterestDate");
        localStorage.removeItem('userType')
        navigate("/");

    }

    //    console.log('quizData' , quizData, quizinfo)
    // let userType = localStorage.getItem('userType')
    return (
        <main>
            {/* <Header /> */}

            {/* SIGN UP START */}

            <ToastContainer
                id="toastContainer"
                position="bottom-right"
            />
            <div className="signin-wrapper">
                <div className="logo_section">
                    <img src={logo} className="logo" alt="Company Logo" />
                    <button className="close-btn" id="close-button-signup" onClick={(e) => handleBack(e)}>
                        <span className="material-icons">close</span>
                    </button>
                </div>

                <div className="card sign-up-wrapper">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12 client-details-section">

                                {!showOtpBox ? (<>
                                    <div className="select_plan" id="select-plan-signup">
                                        {/* <div className="icon">
                                            <img src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/user-profile.svg" alt="User Profile" />
                                        </div> */}
                                        <div className="text">
                                            <h6><span className="me-1"></span>Sign Up</h6>
                                            <p>Add all information about your account</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="input_group_wrapper">
                                                <label className="form_label">Name<span style={{color:'red'}}>*</span></label>
                                                <div className="input_group">
                                                    <div className="icon_wrapper">
                                                        <span className="material-symbols-outlined">account_circle</span>
                                                    </div>
                                                    <input type="text" id="name-signup" className="form-control" name="name" onChange={handleChange} value={formData?.name} placeholder="Name" />
                                                    {errorDisplay && <span className="errormsg" style={{

                                                    }}>{errorData?.name}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input_group_wrapper">
                                                <label className="form_label">Email<span style={{color:'red'}}>*</span></label>
                                                <div className="input_group" >
                                                    <div className="icon_wrapper">
                                                        <span className="material-symbols-outlined">mail</span>
                                                    </div>
                                                    <input type="text" className="form-control" name="email" onChange={handleChange} value={formData?.email} placeholder="Email" id="email-signup" />
                                                    {errorDisplay && <span className="errormsg" style={{
                                                    }}>{errorData?.email}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <div className="input_group_wrapper">
                                                <label className="form_label">Phone Number</label>
                                                <div className="input_group">
                                                    <div className="icon_wrapper">
                                                        <span className="material-symbols-outlined">call</span>
                                                    </div>
                                                    <input type="text" id="phonenumber-signup" className="form-control" name="phone" placeholder="Phone Number" onChange={handleChange} value={formData?.phone} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <div className="input_group_wrapper">
                                                <label className="form_label">Designation<span style={{color:'red'}}>*</span></label>
                                                <div className="input_group">
                                                    <div className="icon_wrapper">
                                                        <span className="material-symbols-outlined">work</span>
                                                    </div>
                                                    <select id="designation-signup" className="form-control" onChange={handleChange} value={formData?.designation} name="designation">
                                                        <option value="">Select Designation</option>
                                                        <option value="Consultant Dermatologist">Consultant Dermatologist</option>
                                                        <option value="Consultant Pathologist">Consultant Pathologist</option>
                                                        <option value="Dermatopathologist">Dermatopathologist</option>
                                                        <option value="Post-graduate Dermatology">Post-graduate Dermatology</option>
                                                        <option value="Postgraduate- Pathology">Post-graduate Pathology</option>
                                                    </select>
                                                    {errorDisplay && <span className="errormsg" style={{
                                                    }}>{errorData?.designation}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        {/* <div className="col-md-6 mt-3">
                                            <div className="input_group_wrapper">
                                                <label className="form_label">User Type<span style={{color:'red'}}>*</span></label>
                                                <div className="input_group">
                                                    <div className="icon_wrapper">
                                                        <span className="material-symbols-outlined">account_circle</span>
                                                    </div>
                                                    <select id="designation-signup" className="form-control" onChange={handleChange} value={formData?.userType} name="userType">
                                                        <option value="">Select User Type</option>
                                                        <option value="CLINICIAN">Clinician</option>
                                                        <option value="STUDENT">Student</option>
                                                       
                                                    </select>
                                                    {errorDisplay && <span className="errormsg" style={{
                                                    }}>{errorData?.userType}</span>}
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="col-md-6 mt-3">
                                            <div className="input_group_wrapper">
                                                <label className="form_label">Hospital/Clinic</label>
                                                <div className="input_group">
                                                    <div className="icon_wrapper">
                                                        <span className="material-symbols-outlined">health_and_safety</span>
                                                    </div>
                                                    <input type="text" className="form-control" name="clinic" onChange={handleChange} value={formData?.clinic}
                                                        placeholder="Enter Name" id="business-name-signup" />
                                                    {errorDisplay && <span className="errormsg" style={{

                                                    }}>{errorData?.clinic}</span>}
                                                </div>
                                            </div>

                                        </div>

                                        <div className="signin-footer mt-4" id="defaultFooter">
                                                <button onClick={(e) => handleSubmit(e)} type="submit" id="signup-button" className="btn-fill me-3" > {isResendLoading==="signup" ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : ''}Sign Up</button>

                                            </div>
                                            <p className="signup-prompt mt-3">Already have an account? <a href="/login" className="mx-2"> Login Here</a></p>



                                        {/* <div className="col-md-6 mt-3">
                                            <div className="input_group_wrapper">
                                                <label className="form_label">Designation</label>
                                                <div className="input_group">
                                                    <div className="icon_wrapper">
                                                        <span className="material-symbols-outlined">work</span>
                                                    </div>
                                                    <select id="designation-signup" className="form-control" onChange={handleChange} value={formData?.designation} name="designation">
                                                        <option value="">Select Designation</option>
                                                        <option value="Consultant Dermatologist">Consultant Dermatologist</option>
                                                        <option value="Consultant Pathologist">Consultant Pathologist</option>
                                                        <option value="Dermatopathologist">Dermatopathologist</option>
                                                        <option value="Post-graduate Dermatology">Post-graduate Dermatology</option>
                                                        <option value="Postgraduate- Pathology">Post-graduate Pathology</option>
                                                    </select>
                                                    {errorDisplay && <span className="errormsg" style={{
                                                    }}>{errorData?.designation}</span>}
                                                </div>
                                            </div>
                                        </div> */}

                                        <div className="col-md-12 mt-3">
                                            <img src={outlineImg} className="client-login-img" alt="Client Details" />
                                        </div>
                                    </div>
                                </>) : (
                           <div className="input_group_wrapper mb-5" id="signup-otp">
                                        <div className="signin-wrapper" id="signinWrapper">

                                            <div id="otpBox" className="otp-box d-flex gap-5 justify-content-center align-items-center col-lg-12">
                                                <div className="col-lg-6 otp-sideImg">
                                                    <img src={otpImage} alt="" />
                                                </div>
                                                <div className="col-lg-5 d-flex flex-column gap-4">
                                                    <div className="otp-text">
                                                        <h2 className="text-start" id="otpHeading">Enter OTP</h2>
                                                        <p className="text-start otp-para">Please enter the OTP (One-Time Password) send to your registered email to complete your verification</p>
                                                    </div>
                                                    <div>
                                                        <input
                                                            id="otpInput-signup"
                                                            type="text"
                                                            name="otp"
                                                            placeholder="Enter OTP"
                                                            className="form-control otpInput"
                                                            value={otp}
                                                            onChange={handleOTPChange}
                                                        />
                                                        <div id="otpButtons" className="d-flex align-items-center gap-1 justify-content-start">
                                                            <button
                                                                id="verifyOtpButton-signup"
                                                                onClick={verifyOTP}
                                                                disabled={isOtpLoading || !otp || !email}
                                                                className="btn create-quiz-btn mr-10 mb-2 mt-2"
                                                                value={otp}
                                                            >
                                                                {(isOtpLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)} Verify OTP
                                                            </button>
                                                            <button
                                                                id="resendOtpButton-sigup"
                                                                onClick={resendOTP}
                                                                disabled={isResendLoading}
                                                                className="reset-quiz-btn px-3 py-2 mb-lg-0 me-2 mb-2 mt-0"
                                                            >
                                                                {isResendLoading==="resend" ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : null} Resend OTP
                                                            </button>
                                                        </div>
                                                    </div>


                                                    <p className="signup-prompt mt-3 text-start">Already have an account? <a href="/login" className="mx-2"> Login Here</a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}


                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <footer className="login_footer fixed-login-footer" id="loginFooter">
                <div className="container-fluid">
                    <p className="footer-para me-4" id="footerText">� 2025 Dadi. All rights reserved.</p>
                    <p className="footer-para"><a href="/privacy" className="me-2">Privacy</a> <a href="/terms" data-discover="true">Terms of Use</a></p>
                </div>
            </footer>

            <SweetAlert show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={title}
                onConfirm={e => onConfirm()}
            >
            </SweetAlert>
             {/* <SweetAlert show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={title}
                onConfirm={e => onConfirm()}
            >
            </SweetAlert> */}
            {/* <Footer /> */}
        </main>
    );
};

export default SignUp;
